// Fix the id from the Outlook REST API to use it with Graph API
export function fixIdForGraph(source: string): string {
    // Replace / with -
    var result = source.replace(/\//g, "-");

    // Replace + with _
    result = result.replace(/\+/g, "_");

    return result;
}

export function fixIdForOWA(source: string): string {
  // Replace / with -
  var result = source.replace(/\-/g, "/");

  // Replace + with _
  result = result.replace(/\_/g, "+");

  return result;
}

export function setUIMessage(messageText: string, messageType: Office.MailboxEnums.ItemNotificationMessageType): void {
  if (messageType === Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage) {
    const message: Office.NotificationMessageDetails = {
      type: messageType,
      message: messageText,
      icon: "Icon.80x80",
      persistent: true,
    };

    // Show a notification message
    Office.context.mailbox.item.notificationMessages.replaceAsync("CloneMail", message);
  }
  else {
    const message: Office.NotificationMessageDetails = {
      type: messageType,
      message: messageText
    };

    // Show a notification message
    Office.context.mailbox.item.notificationMessages.replaceAsync("CloneMail", message);
  }
}